import { render } from "./UnableToContact.vue?vue&type=template&id=74b0c040&scoped=true&lang=pug"
import script from "./UnableToContact.vue?vue&type=script&lang=js"
export * from "./UnableToContact.vue?vue&type=script&lang=js"

import "./UnableToContact.vue?vue&type=style&index=0&id=74b0c040&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b0c040"]])

export default __exports__